export const getDefaultTemplateBody = (buttonColor = "") => {
  const color = buttonColor || (typeof window !== "undefined" ? localStorage.getItem("org_primary_color") : "") || "#2ca9b8";
  return `<p>Hi [Full Name],</p>
<p>I hope this email finds you well.</p>
<p>At [Organization Name], we greatly value your opinion and are constantly striving to enhance your experience. To achieve this, we invite you to provide your inputs by clicking the link below.</p>
<p><strong>Name:</strong> [Form Name]<br /><strong>End Date:</strong> [Form End Date]</p>
<p style="text-align: center; margin: 12px 0;">
  <a class="email-btn" href="[Form Link]" style="display: inline-block; background-color: ${color}; color: #ffffff; padding: 10px 24px; font-size: 15px; font-weight: 600; text-decoration: none; border-radius: 5px; font-family: 'Poppins', sans-serif; text-align: center;">Click Here</a>
</p>
<p>Rest assured, your responses will remain confidential, and your personal information will be handled with the utmost care. We appreciate your candid feedback and look forward to hearing your thoughts.</p>
<p>Thank you for being a valued member of the [Organization Name] community.</p>
<p>Best regards,<br />[Organization Name]</p>
`;
};

export const defaultTemplateBody = getDefaultTemplateBody();

